<template lang="pug">
.dropdown-row
  .dropdown-row__row(
    @click="toggle"
    :class="{'-active-': isOpen}"
  )
    .dropdown-row__header
      .dropdown-row__header-controll.-full-
        p.dropdown-row__title(
          :class="`dropdown-row__title--size-${sizeTitle}`"
          :title="title"
        ) {{title}}
        Icon.dropdown-row__icon(
          icon="ui-thin-down"
          :class="{'-active-': isOpen}"
        )
      slot(name="header")

  SlideUpDown.dropdown-row__body(
    :active="isOpen"
    :duration="300"
  )
    slot

</template>

<script>
import SlideUpDown from 'vue-slide-up-down';

export default {
  components: {
    SlideUpDown
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    sizeTitle: {
      type: String,
      default: 'md'
    },
    manual: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isOpen: false
  }),
  watch: {
    manual(value) {
      this.isOpen = value;
    }
  },
  methods: {
    toggle() {
      this.isOpen = !this.isOpen;
      this.$emit('isOpen', this.isOpen);
    }
  }
};
</script>
